import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for tap event translation requests
 */
export class TapTranslationRequestService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.TfnTaps.TfnTapTranslationRequestsResponse>;

  constructor(private $resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/tfn-tap-translation-requests/:id');
  }


  /**
   * Function to retrieve a list of tap translation requests
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return this.resource.get(options).$promise;
  }
}
